import { createDecorator } from '../../../../../platform/instantiation/common/instantiation.js';
import { ID_NOTEBOOK_EDITOR_WORKER_SERVICE } from './notebookWorkerService.js';
const INotebookEditorWorkerService = ( createDecorator(ID_NOTEBOOK_EDITOR_WORKER_SERVICE));
export { INotebookEditorWorkerService };
